module.exports = __webpack_public_path__ + "img/point-active.dcf3e97e.svg";